import {useEffect, useState} from "react";
import {unsubscribeNewsletter} from "@zaaaz/shared";
import {useI18n} from "./I18nProvider";

export function UnsubscribeView({hash}: {hash: string}) {
  const {t} = useI18n();
  const [ok, setOk] = useState<boolean | null>(null);
  useEffect(() => {
    unsubscribeNewsletter(hash).then(() => setOk(true)).catch(() => setOk(false));
  }, [hash]);
  if(ok === null) return <p>{t("Loading products...")}</p>;
  return (
    <>
      <h1 className="mainTitle wLine cmsPage"><span>{t("Newsletter unsubscribe")}</span></h1>
      <div className="textZone">
        {ok ? (
          <div className="notfound single">{t("You have been successfully unsubscribed from our newsletter.")}</div>
        ) : (
          <div className="notfound single"><b>{t("Unsubscribe could not be completed.")}</b> {t("Please contact us for assistance.")}</div>
        )}
      </div>
    </>
  );
}
